import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { init as initFullStory } from '@fullstory/browser';

const { FLUZ_FULLSTORY_ORG_ID } = process.env;
if (FLUZ_FULLSTORY_ORG_ID) {
  initFullStory({ orgId: FLUZ_FULLSTORY_ORG_ID });
}

ReactDOM.render(
  /**
   * Since we turned on strict mode,
   * everything using effects will re-render twice.
   * */
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
